document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('contact-page-{{ section.id }}');
  if (!section) return;

  const overlay = section.querySelector('.contact-page__computer--overlay');
  if (!overlay) return;

  setTimeout(function () {
    overlay.classList.add('is-visible');
  }, 1000);
});